// store/store.ts
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import type { Api } from '@reduxjs/toolkit/query/react'

// You can tighten these types if you want, but this works well with your factories:
export const createDynamicStore = (
  chatApiSlice: Api<any, any, string, any, any>,
  agentApiSlice: Api<any, any, string, any, any>,
  modeApiSlice: Api<any, any, string, any, any>
) => {
  const store = configureStore({
    reducer: {
      [chatApiSlice.reducerPath]: chatApiSlice.reducer,
      [agentApiSlice.reducerPath]: agentApiSlice.reducer,
      [modeApiSlice.reducerPath]: modeApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        chatApiSlice.middleware,
        agentApiSlice.middleware,
        modeApiSlice.middleware,
      ),
  })

  setupListeners(store.dispatch)
  return store
}

// Optional helpers if you want to use them elsewhere:
// export type AppStore = ReturnType<typeof createDynamicStore>
// export type AppDispatch = AppStore['dispatch']
